import React from 'react';

const SolveResult = ({ solveResult, algorithms, locations }) => {
  if (!solveResult) return null;
  
  return (
    <div className="solve-result">
      <h5>Solve Result</h5>
      <div className="result-details">
        <p><strong>Total Distance:</strong> {solveResult.distance.toFixed(2)} km</p>
        <p><strong>Estimated Time:</strong> {solveResult.time.toFixed(0)} minutes</p>
        <p><strong>Algorithm Used:</strong> {algorithms[solveResult.algorithm]?.name || solveResult.algorithm}</p>
        <p><strong>Required Vehicles:</strong> {
          // Prioritize vehiclePaths.length, the most intuitive vehicle count
          (solveResult.vehiclePaths && solveResult.vehiclePaths.length > 0)
            ? `${solveResult.vehiclePaths.length}` 
            : (solveResult.vehicleCount 
              ? `${solveResult.vehicleCount}` 
              : "N/A")
        }</p>
        {solveResult.maxCapacity > 0 && (
          <p><strong>Max Capacity:</strong> {solveResult.maxCapacity} points per vehicle</p>
        )}
        
        {solveResult.vehiclePaths && solveResult.vehiclePaths.length > 1 ? (
          // Multi-vehicle path display
          <div className="vehicle-paths-result">
            <p><strong>Vehicle Paths:</strong></p>
            {solveResult.vehiclePaths.map((vehicle, index) => (
              <div key={vehicle.id || index} className="vehicle-path-item">
                <div className="vehicle-path-header" style={{background: vehicle.color || '#2196F3'}}>
                  <span>Vehicle {index + 1}</span>
                  <span>{vehicle.distance?.toFixed(2) || 'Unknown'} km</span>
                </div>
                <div className="path-sequence">
                  {vehicle.path.map((point, pointIndex) => {
                    const loc = typeof point === 'string' 
                      ? locations.find(l => l.id === point)
                      : (point.id 
                        ? locations.find(l => l.id === point.id) 
                        : point);
                    const pointName = loc ? (loc.name || loc.id) : (point.id || point);
                    return (
                      <div key={`${pointName}-${pointIndex}`} className="path-point">
                        <span className="path-name">{pointName}</span>
                        {pointIndex < vehicle.path.length - 1 && <span className="path-arrow">→</span>}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        ) : (
          // Single path display
          <div>
            <p><strong>Path Sequence:</strong></p>
            <div className="path-sequence">
              {solveResult.path.map((id, index) => {
                const loc = locations.find(l => l.id === id);
                return (
                  <div key={`${id}-${index}`} className="path-point">
                    <span className="path-name">{loc ? loc.name : id}</span>
                    {index < solveResult.path.length - 1 && <span className="path-arrow">→</span>}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SolveResult; 